import React, { useState } from "react";

import { IconButton } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { ChevronDown } from "Components/Generic/Icons/ChevronDown";
import { ChevronUp } from "Components/Generic/Icons/ChevronUp";
import { formatInTimeZone } from "date-fns-tz";
import { useTranslation } from "react-i18next";
import { calcTotalItems } from "Util/calcTotalItems";
import { formatDateWithUserPref } from "Util/dateFormaterPreference";
import { useAppState } from "Context/StateContext";

import BadgeItemJobStatus from "../../../../../../../components/Generic/BadgeItemJobStatus";
import { ItemJob } from "../../../../../../../models/sales";
import { getMeasurement, getWeightMeasurement } from "../../../../../../../util/getMeasurement";
import useStyles, {
  ItemInfo,
  ItemInfoText,
  ItemInfoWrapper,
  ItemTitle,
  RoomInfoHeader,
  RoomInfoText,
  RoomItemCard,
  RoomItemsInfo,
  RoomItemsWrapper,
  RoomName,
} from "./styles";

interface RoomItemsProps {
  roomName?: string;
  roomItems?: ItemJob[];
}

export const RoomItemsMobile = ({ roomName, roomItems }: RoomItemsProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();
  const classes = useStyles();

  const measurement = getMeasurement();
  const weightMeasurement = getWeightMeasurement();
  const { totalWeight, totalQuantity } = calcTotalItems({
    items: roomItems,
    measurement,
    weightMeasurement,
  });

  return (
    <div>
      <RoomInfoHeader>
        <div>
          <RoomName>{roomName || ""}</RoomName>
          <RoomItemsInfo>
            <li>
              <RoomInfoText>
                {totalQuantity} {totalQuantity > 1 ? translate("items") : translate("item")}
              </RoomInfoText>
            </li>
            <li>
              <RoomInfoText>
                {totalWeight} {weightMeasurement?.code}
              </RoomInfoText>
            </li>
          </RoomItemsInfo>
        </div>
        <IconButton
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? (
            <ChevronUp width={20} height={20} color={colors.gray600} />
          ) : (
            <ChevronDown width={20} height={20} color={colors.gray600} />
          )}
        </IconButton>
      </RoomInfoHeader>
      {isExpanded && roomItems?.length && (
        <RoomItemsWrapper>
          {roomItems?.map((item, index) => (
            <RoomItemCard key={item?.id || index}>
              <RoomInfoHeader>
                <ItemTitle>
                  {index + 1} - {item?.description || ""}
                </ItemTitle>
                <BadgeItemJobStatus className={classes.badge} value={item?.status} />
              </RoomInfoHeader>

              <ItemInfoWrapper>
                <div>
                  <ItemInfoText>{translate("packagingType")}</ItemInfoText>:{" "}
                  <ItemInfo>{item?.itemType?.name || "--"}</ItemInfo>
                </div>
                <div>
                  <ItemInfoText>{translate("lastUpdate")}</ItemInfoText>:{" "}
                  <ItemInfo>
                    {item?.updatedAt
                      ? formatDateWithUserPref(item.updatedAt, currentUser!.preferences!)
                      : formatDateWithUserPref(new Date(), currentUser!.preferences!)}
                  </ItemInfo>
                </div>
              </ItemInfoWrapper>
            </RoomItemCard>
          ))}
        </RoomItemsWrapper>
      )}
    </div>
  );
};
